import { ChartNoAxesColumn, Megaphone, Send, ShieldCheck, UserPlus, UsersRound } from 'lucide-react';
import type { NavItem } from 'shared/components/AppShell';
import { paths } from 'shared/routing/paths';

export const OPERATIONS_NAV: NavItem[] = [
  { label: 'Campaigns', to: paths.operations.campaigns, icon: Megaphone },
  { label: 'Expert Pools', to: paths.operations.expertPools, icon: UsersRound },
  { label: 'Outreach', to: paths.operations.outreach, icon: Send },
  { label: 'Applications', to: paths.operations.applications, icon: UserPlus },
  { label: 'Screening Reviews', to: paths.operations.screeningReviews, icon: ShieldCheck },
  { label: 'New Expert Tracker', to: paths.operations.newExpertTracker, icon: ChartNoAxesColumn },
];
